export default "<div id=\"div_fdic_standard_footer\"></div>\n";